import { defineMessages } from 'react-intl';

export default defineMessages({
  invalidDocuments: {
    id: 'cc4.seo.document-upload-invalid.title',
    defaultMessage:
      "Please upload a copy of your passport including the signature page, or an ID front and backside (a driver's license and/or residence permit is not accepted).",
  },
  passengerNotFound: {
    id: 'cc4.seo.document-upload-passenger-not-found.title',
    defaultMessage:
      'The passenger for this passport could not be found. Please select the passenger from the list:',
  },
  passengerLabel: {
    id: 'cc4.seo.document-upload-passenger-not-found.label',
    defaultMessage: 'Passenger',
  },
  closeButton: {
    id: 'cc4.seo.document-upload-close.button',
    defaultMessage: 'Close',
  },
  cancelButton: {
    id: 'cc4.seo.document-upload-cancel.button',
    defaultMessage: 'Cancel',
  },
  updateButton: {
    id: 'cc4.seo.document-upload-update.button',
    defaultMessage: 'Update',
  },
  submitButton: {
    id: 'cc4.seo.document-upload-submit.button',
    defaultMessage: 'Submit',
  },
  selectPassengerPlaceholder: {
    id: 'cc4.seo.document-select-passenger.placeholder',
    defaultMessage: 'Select a passenger',
  },
  addNewPassengerOption: {
    id: 'cc4.seo.document-select-add-new-passenger.option',
    defaultMessage: 'Add new passenger',
  },
  firstNameLabel: {
    id: 'cc4.form.personal-info.label.first-name',
    defaultMessage: 'First name',
  },
  lastNameLabel: {
    id: 'cc4.form.personal-info.label.last-name',
    defaultMessage: 'Last name',
  },
  dateOfBirthLabel: {
    id: 'cc4.seo.document-select-date-of-birth.label',
    defaultMessage: 'Date of birth',
  },
});
